import {Contact, Product, SaleHistory, SaleHistoryEventType} from "@/models/base";
import {Sale} from "@/models/base";
import {SaleRow} from "@/models/base";
import {SaleType} from "@/models/base";
import {DossierConfigService} from "@/services/dossier-config-service";
import {SaleService} from "@/services/sale-service";
import {SaleEditLoyalty} from "./sale-edit-loyalty";
import {CombinedVueInstance} from "vue/types/vue";
import {EventEmitter} from "../event-emitter";
import router from "@/router";
import {UserConfigService} from "@/services/user-config-service";
import {PrintSendSetting, SaleConfig} from "@/models/dossier-configs/sale-config";
import {BookYearService} from "@/services/book-year-service";
import {VatService, isVatRegimeStaticVat} from "@/services/vat-service";
import {Permissions} from "@/models/user-configs/permissions";
import {HttpError} from "../services/http-error";
import {AllContactsService} from "@/services/all-contacts-service";
import {OpenClientInfoModalAfterSelectOptions, SaleSettings} from "@/models/user-configs/sale-settings";
import {AuthService} from "@/services/auth-service";
import {SaleEditStateSaveModalData} from "./sale-edit-state-save-modal-data";
import {SaleEditStateCreatedDeposits} from "./sale-edit-state-created-deposits";
import {SaleEditStateLoadDepositsData} from "./sale-edit-state-load-deposits-data";
import {PrintContext, SalePrintSettings} from "../sale-layouts/print-settings";
import {MODULE} from "@/config/modules";
import {ContactPriceRule} from "@/models/base/contact-price-rule";
import {Condition, Operator} from "../condition/condition";
import {getContactServiceByGroupId} from "../services/contact-services";
import {ContactService} from "../services/contact-service";
import {SaleEditRowState} from "./sale-edit-row-state";
import {ProductService} from "@/services/product-service";
import {CustomerService} from "@/services/customer-service";
import {LOYALTY_BARCODE_PREFIX} from "@/models/dossier-configs/loyalty";
import {i18n} from "@/setup/i18n-setup";
import { CarpassInputModalState } from "../carpass-input-modal-state";
import { TranslateResult } from "vue-i18n";
import { v4 } from "uuid";
import { SaleEditStateContactExtraInfoEdit } from "./sale-edit-state-contact-extra-info-edit";
import { StockLocationConfig } from "@/models/dossier-configs/stock-location";
import {CheckVies} from "@/models/check-vies";
import {printLocalDateTime} from "@/utils/pretty-print";
import {RecoverySale} from "@/models/base/recovery-sale";
import {RecoveryService} from "@/services/recovery-service";
import { SaleEditCreateCalendarEventState } from "./sale-edit-create-calendar-event-state";
import { AddToAutomaticOrderToSupplier } from "@/models/dossier-configs/stock-location-settings";
import { SaleEditOpenedClientWatcher } from "./sale-edit-opened-clients-watcher";
import { AutoSaleRowSetting } from "./auto-sale-row-setting";
import {SaleConfigs} from "@/models/dossier-configs/sale-configs";
import { csvToSaleRows, ICsvToSaleRowsOptions } from "./csv-to-sale-rows";
import {ContactsConfig} from "@/models/dossier-configs/contacts";
import { runPriceRules } from "../price-rule";
import { GeneralPriceRuleService } from "@/services/general-price-rule-service";
import { GeneralPriceRule } from "@/models/base/general-price-rule";
import { CarService, ProductGroupService } from "@/services";
import { SizeTableService } from "@/services/size-table-service";
import { Fostplus } from "@/models/base/fostplus";
import { FostplusService } from "@/services/fostplus-service";
import { SaleEditSelectProductTrackingNumbersData } from "./sale-edit-state-select-product-tracking-numbers-data";
import { PeppolService } from "@/services/peppol-service";
import { CurrencyService } from "@/services/currency-service";
import { SaleEditStateCarSelectData } from "./sale-edit-state-car-select-data";
import { ScannerListener } from "../scanner";
import { SaleEditRowSelection } from "./sale-edit-row-selection";
import { ConfirmResult } from "winfakt-vue-components";
import { trackEvent } from "../analytics";
import * as services from "@/services";

export enum LoadCsvRowsModalState {
	CLOSED = 0,
	OPEN = 1,
	PROCESSING = 2
}

export interface IImportSalesModalState{
	shown:boolean;
	saleRowsShown:boolean;
	disableContentFilter:boolean;
	contactGroupId:number;
}

export interface IPublicLinkModalState{
	shown:boolean;
	link:string;
}

export class SaleEditState extends EventEmitter {
	public config: null | SaleConfig = null;

	public contactsConfig: null | ContactsConfig = null;
	public dossierConfig : null | SaleConfigs = null;
	public readonly userConfig: SaleSettings = UserConfigService.getSaleSettings();
	public profitVisible: boolean = false;
	public stockInfoVisible: boolean = false;
	public sendModalOpen: boolean = false;
	public bankEditOpen: boolean = false;
	public selectedRow: SaleRow = new SaleRow();
	public readonly rowSelection: SaleEditRowSelection = new SaleEditRowSelection(this);
	public sale: Sale = new Sale();
	public saveModalOpen: boolean = false;
	public ticketRefundModalOpen: boolean = false;
	public readonly loyalty: SaleEditLoyalty = new SaleEditLoyalty(this);
	public wrongBookYearWarningModal: boolean = false;
	public callBackTask: (keyof SaleEditState) | "" = "";
	public DefaultVAT: number = 0;
	public mobileCurrentPage: number = 1;
	public typeChanged: boolean = false;
	public saveModalData: SaleEditStateSaveModalData = new SaleEditStateSaveModalData();
	public preventRedirect: boolean = false;
	public loadDepositsData: SaleEditStateLoadDepositsData = new SaleEditStateLoadDepositsData();
	public createdDepositsData: SaleEditStateCreatedDeposits = new SaleEditStateCreatedDeposits();
	public documentsModal: boolean = false;
	public previewModal: boolean = false;
	public readonly productEditRowState: SaleEditRowState;
	public favvProduct: Product = new Product();
	public isPrintingPreview: boolean = false;
	public lastPurchaseModalOpen: boolean = false;
	public printExtraOptionsModalOpen: boolean = false;
	public contactInfoModal:OpenClientInfoModalAfterSelectOptions = OpenClientInfoModalAfterSelectOptions.OFF;
	private _contactGroupId: number = 0;
	public carSelectData:SaleEditStateCarSelectData = new SaleEditStateCarSelectData();
	public carpassModalData:CarpassInputModalState = new CarpassInputModalState();
	public processingMessage:TranslateResult | null = null;
	public addRowsAutoHidden:boolean = false;

	public justScannedRow:SaleRow | null = null;
	public justScannedRowWasScannedThisTick:boolean = false;
	private justScannedRowThreadId:string = "";
	public readonly justScannedRowEffectTime:number = 3000;
	public contactExtraInfoEditState:SaleEditStateContactExtraInfoEdit = new SaleEditStateContactExtraInfoEdit();
	public isSaving:boolean = false;
	public recoverySale:RecoverySale = new RecoverySale();
	public sortRowsModalOpen:boolean = false;
	public createCalendarEventState:SaleEditCreateCalendarEventState = new SaleEditCreateCalendarEventState();
	public hiddenRowsAreInvisble:boolean = false;
	public addProductsWithNotEnoughInStockBySelectedSupplierSelectGroupModalOpen:boolean = false;
	public openedClientsWatcher:SaleEditOpenedClientWatcher = new SaleEditOpenedClientWatcher();
	private readonly autoSaleRowSettings:AutoSaleRowSetting[] = SaleService.getAutoSaleRowSettings();
	public overrideFriendlyId:boolean = false;
	public csvRowsModalState:LoadCsvRowsModalState = LoadCsvRowsModalState.CLOSED;
	public generalPriceRules:GeneralPriceRule[] = [];
	public applyDiscountModal:boolean = false;

	public sendUblCopyToBookkeeper:boolean = false;
	public ProductTrackingNumbersData:SaleEditSelectProductTrackingNumbersData;
	public toEditRowExtraFields:SaleRow | null = null;
	public showImageUploadModal:boolean = false;
	public importSalesModal:IImportSalesModalState = {
		shown: false,
		saleRowsShown: false,
		disableContentFilter: false,
		contactGroupId: 0
	};
	public publicLinkModal:IPublicLinkModalState = {
		shown: false,
		link: ""
	}
	public editExtraFieldsModal:boolean = false;

	private fetchedNextComputedFriendlyId = {
		computedFriendlyId: "",
		friendlyId: 0,
		journalId: 0,
		typeId: 0
	};

	private savedComputedFriendlyId = {
		computedFriendlyId: "",
		friendlyId: 0,
		journalId: 0,
		typeId: 0,
		overridePreventFetch: false
	};

	public get shouldUseMobileLayout():boolean{
		return !this.vue.$wf.isLgUp;
	}

	private fostplusItems:Fostplus[] = [];
	public vue:CombinedVueInstance<any, any, any, any, any>;

	public constructor(vue: CombinedVueInstance<any, any, any, any, any>, contactGroupId: number) {
		super();
		this.vue = vue;
		this._contactGroupId = contactGroupId;
		this.productEditRowState = new SaleEditRowState(this);
		this.ProductTrackingNumbersData = new SaleEditSelectProductTrackingNumbersData(this);
	}

	public async setSale(sale: Sale) {
		this.sale = sale;
		this.savedComputedFriendlyId.computedFriendlyId = this.sale.ComputedFriendlyID;
		this.savedComputedFriendlyId.friendlyId = this.sale.FriendlyID;
		this.savedComputedFriendlyId.journalId = this.sale.JournalID;
		this.savedComputedFriendlyId.typeId = this.sale.TypeID;
		this.openedClientsWatcher.setSaleId(sale.ID);
		// Disable fetching of friendly id if loaded from json
		if (sale.ComputedFriendlyID && this.sale.ID == 0) {
			this.savedComputedFriendlyId.overridePreventFetch = true;
		}
		this.getSaleConfig();
		let regime = VatService.getVatRegime(this.sale.VatRegime);
		this.DefaultVAT = regime.getSaleVat();
		if (this.userConfig !== null) {
			this.profitVisible = this.userConfig.ShowProfitBar;
			this.stockInfoVisible = this.userConfig.ShowStockInfo;
		}
		if (this.sale.ID == 0) {
			if (this.sale.TypeID != 0) {
				let saleType = await SaleService.getType(this.sale.TypeID);
				this.setSaleType(saleType);
			}
		}
		this.productEditRowState.setVatByRegime();
		this.generalPriceRules = await GeneralPriceRuleService.getPriceRules();
		await this.fetchFostplusItems();
	}

	public async fetchFostplusItems(){
		if (!AuthService.hasModule(MODULE.TAKSENVERWERKING)) return;
		this.fostplusItems = await FostplusService.fetchFostplusItemsByYear(this.sale.InvoiceDate.getFullYear());
	}

	public getContactGroupName():string {
		let contactGroupId = this.getContactGroupID();
		return i18n.t(`common.contact-group.${contactGroupId}`).toString();
	}

	public async getRecoverySale(){
		let lSd = UserConfigService.getSaleSettings().LastSalesRecoveryID;
		if(this.sale.ID > 0){
			this.recoverySale = await RecoveryService.getBySaleID(this.sale.ID);
		}else if(lSd){
			this.recoverySale = await RecoveryService.get(lSd);
		}
	}

	public async recoverSale(){
		let s = new Sale(this.recoverySale.JsonData);
		if (!s.Contact && s.ContactID) {
			s.Contact = await this.getContactService().getContact(s.ContactID);
		}
		this.sale = s;
		this.recoverySale = new RecoverySale();
	}

	public restoreRecovery() {
		let r = localStorage.getItem("sale-recovery-item");
		if (r) {
			let a = JSON.parse(r);
			let b = a[a.length - 1];
			b.Rows.forEach((row: SaleRow) => {
				this.sale.Rows.push(new SaleRow(row));
			});
		}
	}

	public saveRecovery(sale: Sale) {
		let r = localStorage.getItem("sale-recovery-item");
		if (r) {
			if (sale.Rows.length) {
				let jR = JSON.parse(r);
				jR.push(sale);
				if (jR.length == 3) {
					jR = jR.splice();
				}
				localStorage.setItem("sale-recovery-item", JSON.stringify(jR));
			}
		} else if (sale.Rows.length) {
			localStorage.setItem("sale-recovery-item", JSON.stringify([sale]));
		}
	}

	public getContactLng(): string {
		if (this.sale.Contact) {
			if (this.sale.Contact.MainAddress) {
				return this.sale.Contact.MainAddress.Lng;
			}
		}
		return "nl-be";
	}

	public mergeSaleRows(){

		let itemMap: { [key: string]: SaleRow } = {};

		this.sale.Rows.forEach((item,index) => {
			if(item.ProductSku == ""){
				itemMap[" " + index] = item;
				return;
			}
			let key = " " + item.ProductSku + "|" + (item.SizeTableEntryID ?? "");
			if (itemMap[key]) {
				itemMap[key].Amount1 += item.Amount1;
				itemMap[key].Amount += this.dossierConfig?.UseAmount2AsMultiplier ? item.Amount1 * item.Amount2 : item.Amount1;
			} else {
				itemMap[key] = item;
			}
		});

		this.sale.Rows = Object.values(itemMap);
		this.sale.calculateTotals();
	}

	public getContactGroupID(): number {
		return this._contactGroupId;
	}

	public getSaleConfig() {
		this.config = DossierConfigService.getSaleConfig(this.sale.TypeID);
		this.dossierConfig = DossierConfigService.getSaleConfigs();
		this.contactsConfig = DossierConfigService.getContactsConfig();
	}

	public async selectContactOpenContactInfo(contact:Contact){
		let settings = UserConfigService.getSaleSettings().OpenClientInfoModalAfterSelect;
		if (settings == OpenClientInfoModalAfterSelectOptions.OFF) return;
		//if (settings == OpenClientInfoModalAfterSelectOptions.INFO) {
		//let stats = await CustomerService.getClientStats(contact.ID);
		//if (stats.Expired == 0 && stats.Open == 0 && stats.TotalExpired == 0 && stats.TotalOpen == 0) return;
		//}
		if (settings == OpenClientInfoModalAfterSelectOptions.EXTRA_FIELDS) {
			if (!contact.ExtraFields) return;
			let nameSettings = DossierConfigService.getExtraFieldNamesConfigs().getContactNamesByGroupID(contact.GroupID);
			if (contact.ExtraFields.areSettingsEmpty(nameSettings)) return;
		}
		this.contactInfoModal = UserConfigService.getSaleSettings().OpenClientInfoModalAfterSelect;
	}

	// eslint-disable-next-line max-lines-per-function
	public async selectContact(contact: Contact) {
		this.sale.CompanyName = "";
		let c = await AllContactsService.getContactByID(contact.ID);//ContactService.getContactsByIDs(contact.ID);
		if (this.sale.ContactID != c.ID) {
			this.sale.PriceCategory = c.SellPriceCategory || 1;
			this.sale.DeliveryAddressID = null;
			this.sale.DeliveryAddress = null;
			this.sale.InvoiceAddressID = c.MainAddressID;
			this.sale.InvoiceAddress = c.MainAddress;
			if(this.sale.JournalID == 1){
				this.sale.JournalID = c.DefaultJournalID || 1;
			}
			if(c.CurrencyID > 1){
				this.sale.CurrencyID = c.CurrencyID || 1;
			}
		}
		this.sale.PriceCategory = c.SellPriceCategory || 1;
		this.sale.ContactID = c.ID;
		this.sale.Contact = c;
		this.sale.VatRegime = c.VatRegime || this.sale.VatRegime || 1;

		if(this.contactsConfig?.ContactSelectVatID && this.sale.Contact.DefaultVatID!=null){
			this.productEditRowState.vatItem = VatService.getVatById(this.sale.Contact.DefaultVatID);
		}else{
			let regime = VatService.getVatRegime(this.sale.VatRegime);
			this.DefaultVAT = regime.getSaleVat();
			this.productEditRowState.vatItem = VatService.getVatByValue(this.DefaultVAT);
		}

		if (c.MainAddress) {
			this.sale.CompanyName = c.MainAddress.CompanyName || "";
			if (AuthService.hasModule(MODULE.MULTITALEN)) {
				this.setLng(c.MainAddress.Lng);
			}
		}
		this.setExpirationDateFromInvoiceDate();
		this.checkAndSetQuotationExpirationDate();
		this.sale.PaymentBeforeDiscountPercent = contact.DiscountCash;
		this.sale.PaymentBeforeDiscountDate = new Date(this.sale.InvoiceDate.toJSON());
		this.sale.PaymentBeforeDiscountDate.setDate(new Date().getDate() + contact.DiscountCashDays);
		this.sale.calculateTotals();
		this.setToPrintMessage(true);
		try {
			await this.fetchDeposits();
		} catch (err) {
			let e = err as HttpError;
			e.dontShow = true;
		}

		await this.selectContactOpenContactInfo(c);
		if (DossierConfigService.getSaleConfigs().ViesCheckExtraField != ""){
			await this.setViesInfo();
		}
		await this.selectContactSetRowDiscounts();
		await this.loyalty.loadBalance();
	}

	private setExpirationDateFromInvoiceDate(){
		let date = new Date(this.sale.InvoiceDate.getTime());
		//overrule expiration date
		if(this.config && this.config.EnableExpirationDays){
			date.setDate(date.getDate() + this.config.DaysUntilExpiration);
			this.sale.ExpirationDate = date;
			return;
		}
		if (!this.sale.Contact) return;
		if (this.sale.Contact.PaymentEndMonth) {
			date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
		}
		date.setDate(date.getDate() + this.sale.Contact.PaymentDays || 30);
		this.sale.ExpirationDate = date;
	}

	public async setInvoiceDate(date:Date){
		this.sale.InvoiceDate = date;
		this.setExpirationDateFromInvoiceDate();
		await this.fetchFostplusItems();
		this.processFostplus();
	}

	private async selectContactSetRowDiscounts() {

		let isCashier = this.vue.$route.path.includes("cashier");

		if(isCashier) return;

		if (!this.sale.Contact) return;
		let shouldAskToApplyDefaultDiscount = false;
		for (let row of this.sale.Rows) {
			if (row.Discount != this.sale.Contact.Discount){
				shouldAskToApplyDefaultDiscount = true;
				break;
			}
		}
		if (!shouldAskToApplyDefaultDiscount) return;
		let message = this.vue.$ct("components.sales.do-you-want-to-apply-contact-default-discount", {percent: this.sale.Contact.Discount});
		let confirm = await this.vue.$wf.confirm(message,  this.vue.$t("common.yes"), this.vue.$t("common.no"), this.vue.$ct("common.warning"), "info");
		if (!confirm) return;
		for (let row of this.sale.Rows) {
			if (row.Product && row.Product.DiscountsDisabled) continue;
			row.Discount = this.sale.Contact.Discount;
			row.Discount = this.computeRowDiscount(row);
		}
	}

	private async fetchDeposits(): Promise<void> {
		this.loadDepositsData.foundDeposits = await SaleService.getDepositsByContactID(this.sale.ContactID);
		if (this.loadDepositsData.foundDeposits.length > 0) {
			this.loadDepositsData.modal = true;
			this.loadDepositsData.selectedDeposits = [];
		}
	}

	public async setViesInfo() {
		let cc = this.sale.Contact?.MainAddress?.CountryCode || "BE";
		if(this.sale.Contact?.Vat && cc){
			let v = await AllContactsService.checkVies(this.sale.Contact.Vat,cc) as CheckVies;
			let e = DossierConfigService.getSaleConfigs().ViesCheckExtraField;
			let t;
			if(v == null){
				t = "Vies service niet bereikbaar";
				t += "\nBTW-nummer: " + this.sale.Contact.Vat || "";
				t += "\nTijdstip: " + printLocalDateTime(new Date());
			}else{
				t = "Geldig: " + (v.valid ? "Ja" : "Neen");
				t += "\nIdentificatie: " + (v.identifier == "" ? "-" : v.identifier);
				t += "\nNaam: " + (v.name == "" ? "-" : v.name);
				t += "\nBTW-nummer: " + this.sale.Contact.Vat || "";
				t += "\nTijdstip: " + printLocalDateTime(new Date(v.timestamp));
			}
			if(this.sale.ExtraFields){
				((this.sale.ExtraFields) as any)[e] = t;
			}
		}
	}

	public setToPrintMessage(override: boolean = false) {
		if (!this.config) return;
		if (this.sale.ToPrintMessage == "" || override) {
			this.sale.ToPrintMessage = this.config.DefaultComment.getTranslation(this.sale.getLng());
		}
	}

	public getUsedLayoutID(context: PrintContext): number {
		let layoutID = this.sale.LayoutID;
		if (!layoutID) {
			let layoutIDs = DossierConfigService.getSaleConfig(this.sale.TypeID).getLayoutIds(context);
			if (layoutIDs.length == 0) {
				return 0;
			}
			return layoutIDs[0];
		}
		return layoutID;
	}

	public async openBankEditModal(): Promise<void> {
		this.bankEditOpen = true;
	}

	private setDefaultDeliveryAddresss(){
		if (!this.config) return;
		if (!this.config.UseDefaultDeliveryAddress) return;
		if (this.sale.DeliveryAddressID != null) return;
		if (!this.sale.Contact || !this.sale.Contact.DefaultDeliveryAddressID) return;
		this.sale.DeliveryAddressID = this.sale.Contact.DefaultDeliveryAddressID;
	}

	public async checkIfTotalIsOkay():Promise<boolean>{
		if (this.sale.TypeID == 1 && this.sale.TotalIncVAT < 0) {
			let message = i18n.t("components.sales.total-inc-vat-is-below-0-are-you-sure-you-want-to-continue");
			return this.vue.$confirmBuilder().setWarningTitle().setMessage(message).show();
		}
		if (this.sale.TypeID == 2 && this.sale.TotalIncVAT > 0) {
			let message = i18n.t("components.sales.total-inc-vat-is-above-0-are-you-sure-you-want-to-continue");
			return this.vue.$confirmBuilder().setWarningTitle().setMessage(message).show();
		}
		return true;
	}

	public async openSaveModal(){
		this.setDefaultDeliveryAddresss();
		if (!await this.checkIfTotalIsOkay()) return;
		this.saveModalOpen = true;
	}

	public async openSendModal(): Promise<void> {
		this.saveModalOpen = false;
		this.sendModalOpen = true;
	}

	public async printPreview() {
		trackEvent("sale_edit_print_preview", {
			saleId: this.sale.ID,
			rowCount: this.sale.Rows.length,
		});
		this.isPrintingPreview = true;
		try {
			this.sale.calculateTotals();
			await SaleService.printPreview(this.sale);
		} catch (err) {
		}
		this.isPrintingPreview = false;
	}

	public async checkIfComputedFriendlyIDExists(): Promise<boolean> {
		if (this.overrideFriendlyId == false && this.sale.ID == 0) {
			return false;
		}
		try {
			let foundSale = await SaleService.checkIfFriendlyIdExists(this.sale.ComputedFriendlyID);
			if (foundSale) {
				if (foundSale.ID == this.sale.ID) {
					return false;
				}
				return true;
			}
			return false;
		} catch (err) {
			let error = err as HttpError;
			if (error.status == 404) {
				error.dontShow = true;
				return false;
			}
		}
		return false;
	}

	public showComputedFriendlyIDAlreadInUseDialog() {
		let message = this.vue.$ct("components.sales.sale-friendly-id-already-in-use");
		this.vue.$wf.dialog(message, this.vue.$ct("common.ok"), this.vue.$ct("common.save-failed"));
	}

	public async closeEditModal() {
		this.emit("close");
	}

	// eslint-disable-next-line max-lines-per-function
	public async save(): Promise<boolean> {
		await this.runAutoSaleRowSettings();
		if (this.isSaving) return false;
		this.isSaving = true;
		try{
			let supposedBookyear = BookYearService.getBookYearFromDate(this.sale.InvoiceDate);
			if (supposedBookyear != BookYearService.selectedBookYear && this.sale.ID == 0) {
				let confirm = await (this.vue.$confirmBuilder(this.vue.$ct("components.sales.confirm-wrong-bookyear")).setWarningTitle().show());
				if (!confirm) return false;
			}

			if (this.sale.ID != 0) {
				if (this.sale.ComputedFriendlyID == "") {
					let confirm = await (this.vue.$confirmBuilder(this.vue.$ct("components.sales.alert-id-empty")).setWarningTitle().setClass("primary").show());
					if (!confirm) {
						return false;
					}
				}
			}

			if (this.sale.isSupposedToHaveNegativeTotalType() && this.sale.TotalIncVAT > 0) {
				let confirm = await (this.vue.$confirmBuilder(this.vue.$ct("components.sales.confirm-edit-postive-creditnote")).setWarningTitle().setClass("primary").show());
				if (!confirm) {
					return false;
				}
			}

			if (await this.checkIfComputedFriendlyIDExists()) {
				this.showComputedFriendlyIDAlreadInUseDialog();
				return false;
			}

			this.sale.enforceVatRegime();
			let toCreateDepositAmount = this.sale.ToCreateDeposit;

			let e = DossierConfigService.getSaleConfigs().ViesCheckExtraField;
			if (e != "" && ((this.sale.ExtraFields) as any)[e] == ""){
				await this.setViesInfo();
			}

			if (!this.overrideFriendlyId){
				if (this.sale.ID == 0){
					this.sale.ComputedFriendlyID = "";
					this.sale.FriendlyID = 0;
				}
			}else if (this.sale.ComputedFriendlyID != this.fetchedNextComputedFriendlyId.computedFriendlyId) {
				// Prevent incorrect numbering
				let message = this.vue.$ct("components.sales.confirm-skipping-number", {nr: this.sale.ComputedFriendlyID});
				let confirm = await this.vue.$confirmBuilder().setMessage(message).setWarningTitle().setClass("warning").show();
				if (!confirm) return false;
				this.sale.FriendlyID = 0;
			}


			if (this.sale.ID == 0) {
				this.sale = await SaleService.postSale(this.sale);
				this.savedComputedFriendlyId.overridePreventFetch = false;
			} else {
				this.sale.TotalOpen = 0;
				this.sale = await SaleService.putSale(this.sale);
				if (this.typeChanged) {
					let history = new SaleHistory();
					history.SaleID = this.sale.ID;
					history.EventTypeID = SaleHistoryEventType.SaleTypeChanged;
					history.Props = [
						`${this.savedComputedFriendlyId.typeId}`,
						this.savedComputedFriendlyId.computedFriendlyId,
						`${this.sale.TypeID}`,
						this.sale.ComputedFriendlyID
					];
					history.BookYear = this.sale.BookYear;
					try {
						await SaleService.postSaleHistory([history]);
					} catch (err) {

					}
				}
			}
			this.sale = await SaleService.getSale(this.sale.ID);
			if (toCreateDepositAmount > 0) {
				await this.createBankForDeposit(this.sale);
			}

			await this.deleteRecovery();

			if (this.createCalendarEventState.shouldOpenOnSave){
				await this.createCalendarEventState.show(this.sale);
			}

			if (this.vue.$route.path.startsWith("/sales/new") || this.sale.CarpassRequestId == ""){
				this.sale.CarpassRequestId = this.sale.CarpassRequestId;
				await this.carpassModalData.showCarpassModalIfRequiredFromSaleEdit(this.sale);
			}
			this.emit("saved", this.sale);
			return true;
		}catch(err){
			console.error(err);
		}finally{
			this.isSaving = false;
		}
		return false;
	}

	private async deleteRecovery(){
		await RecoveryService.deleteBySaleID(this.sale.ID);
		let s = UserConfigService.getSaleSettings();
		s.LastSalesRecoveryID = 0;
		await UserConfigService.setSaleSettings(s);
	}

	private async createBankForDeposit(createdSale: Sale): Promise<ConfirmResult> {
		let deposits = await SaleService.getDepositsByCreatedByDocumentId(createdSale.ID);
		if (deposits.length == 0) return ConfirmResult.NO;
		let message = this.vue.$ct("components.sales.ask-create-bank-for-deposit");
		let confirm = await this.vue.$confirmBuilder().setMessage(message).setTitle(this.vue.$ct("components.sales.deposit-invoices-created")).show();
		if (!confirm) return ConfirmResult.NO;
		return this.createdDepositsData.showModal(deposits);
	}

	public async clear() {
		var sale = new Sale();
		sale.Type = await SaleService.getType(1);
		sale.TypeID = 1;
		sale.CurrencyID = 1;
		this.emit("saved", sale);
	}

	public async download(dontSave: boolean = false): Promise<void> {
		if (!this.callBackTask && !dontSave) {
			await this.save();
		}
		//let layoutId = this.getUsedLayoutID(PrintContext.DOWNLOAD);
		await SaleService.downloadAndSaveSale(this.sale, 0);
	}

	private async doPrintWithExtraOptions(): Promise<void> {
		this.printExtraOptionsModalOpen = true;
		return new Promise((resolve, reject) => {
			let emitted = false;
			let onResolve: Function = () => {
				if (emitted) return;
				emitted = true;
				this.off("printed-with-extra-options-closed", onReject);
				resolve();
			};
			let onReject: Function = () => {
				if (emitted) return;
				emitted = true;
				this.off("printed-with-extra-options", onResolve);
				reject("Action cancelled");
			};
			this.once("printed-with-extra-options", onResolve);
			this.once("printed-with-extra-options-closed", onReject);
		});
	}

	private async doPrint(): Promise<void> {
		if (!this.config) return;
		let settings = new SalePrintSettings(PrintContext.PRINT);
		if (this.config.PrintSendSetting == PrintSendSetting.SendAfterPrint) {
			settings.forceSingleCoppy = true;
		}
		if (this.config.AskForExtraPrintOptionsOnSave) {
			await this.doPrintWithExtraOptions();
			return;
		}
		//let layoutId = this.getUsedLayoutID(PrintContext.PRINT);
		await SaleService.printSale(this.sale, 0, settings);
	}

	public async print(dontSave: boolean = false): Promise<void> {
		if (!this.config) return;
		if (!this.callBackTask && !dontSave) {
			await this.save();
		}
		await this.doPrint();
		if (this.config.PrintSendSetting == PrintSendSetting.SendAfterPrint) {
			await this.openSendModal();
		} else {
			this.onFinish();
		}
	}

	public isSubscription(): boolean {
		return this.sale.TypeID == 10;
	}

	public async runCallbackTask() {
		if (this.saveModalData.pendingPeppolSend) {
			await this.sendViaPeppolIfEnabled();
		}
		if (this.callBackTask) {
			await (this as any)[this.callBackTask]();
		}
		this.callBackTask = "";
	}

	public async sendViaPeppolIfEnabled() {
		if (!this.saveModalData.sendViaPeppol) {
			this.saveModalData.pendingPeppolSend = false;
			return;
		}
		const { po, deliveryNumber, files, sendCopyToBookkeeper, endpointID } = this.saveModalData.peppolOptions;
		try {
			await PeppolService.sendSale(this.sale.ID, po, deliveryNumber, files, endpointID);
			this.vue.$wf.notify(this.vue.$ct("components.sales.peppol-document-sent"), "success", 3000, "check");
			if (sendCopyToBookkeeper) {
				await SaleService.batchSendBookkeeper([this.sale]);
			}
			this.saveModalData.sendViaPeppol = false;
		} catch (err) {
			this.vue.$wf.notify(this.vue.$ct("components.sales.peppol-document-send-failed"), "danger", 3000, "exclamation-triangle");
		}
		this.saveModalData.pendingPeppolSend = false;
	}

	private async setSaleTypeChangeToDefaultContactIfRequired(newType:SaleType){
		if (this.sale.ID != 0) return;
		let defaultContactID = this.sale.getDefaultContactID();
		if (!defaultContactID) return;
		if (this.sale.ContactID == defaultContactID) {
			return;
		}
		let c = await this.getContactService().getContact(defaultContactID);
		if (this.sale.ContactID != 0){
			let title = this.vue.$ct("common.warning");
			let message = this.vue.$ct("components.sales.confirm-should-change-contact-to-default-contact", {
				name: c.getDisplayName(),
				saleTypeName: newType.DisplayedName
			});
			let confirm = await this.vue.$confirmBuilder().setTitle(title).setMessage(message).show();
			if (!confirm) return;
		}
		await this.selectContact(c);
	}

	public async setSaleType(newType: SaleType) {
		this.sale.Type = newType;
		this.sale.TypeID = newType.ID;
		this.sale.ComputedFriendlyID = "";
		this.sale.FriendlyID = 0;
		this.getSaleConfig();
		this.setSaleDates();
		this.setToPrintMessage(true);

		if (this.sale.ID != 0) {
			this.typeChanged = true;
			if (this.isSameTypeIdForNumbering(this.sale.TypeID, this.savedComputedFriendlyId.typeId)) {
				this.sale.ComputedFriendlyID = this.savedComputedFriendlyId.computedFriendlyId;
				this.sale.FriendlyID = this.savedComputedFriendlyId.friendlyId;
				this.typeChanged = false;
			}
		}
		await this.setSaleTypeChangeToDefaultContactIfRequired(newType);
		this.checkAndSetQuotationExpirationDate();
		if (this.userConfig.getSaleConfig(this.sale.TypeID || 1).OpenCarSelectModalByDefault && this.sale.ID == 0){
			this.carSelectData.isOpen = true;
		}
	}

	public getContactService(): ContactService {
		return getContactServiceByGroupId(this.getContactGroupID());
	}

	private checkAndSetQuotationExpirationDate() {
		if (this.sale.TypeID == 3 && this.userConfig) {
			let date = new Date();
			if(this.config?.EnableExpirationDays){
				date.setDate(date.getDate() + this.config.DaysUntilExpiration);
				this.sale.ExpirationDate = date;
				return;
			}
			date.setDate(this.sale.InvoiceDate.getDate() + this.userConfig.DefaultQuotationValidDays);
			//overrule expiration date
			this.sale.ExpirationDate = date;
		}
	}

	public setSaleDates() {
		this.sale.InvoiceDate = new Date();
		this.setExpirationDateFromInvoiceDate();

		if (this.sale.Contact && this.sale.PaymentBeforeDiscountPercent>0) {
			this.sale.PaymentBeforeDiscountDate = new Date(this.sale.InvoiceDate.toJSON());
			this.sale.PaymentBeforeDiscountDate.setDate(this.sale.PaymentBeforeDiscountDate.getDate() + this.sale.Contact.DiscountCashDays);
		}
	}

	async clearNotifier() {
		this.emit("saved", this.sale);
	}

	private getCreateNewRoute(): string {
		return `${this.getBrowseRoute()}/new?typeId=${this.sale.TypeID}`;
	}

	private getBrowseRoute(): string {
		if (this._contactGroupId == 2) {
			return "/purchase-documents";
		}
		return "/sales";
	}

	async onFinish() {
		this.saveModalOpen = false;
		await this.clearNotifier();
		await this.closeEditModal();

		if (this.preventRedirect) {
			return;
		}

		let conf = this.userConfig.getSaleConfig(this.sale.TypeID);

		let settings = UserConfigService.getSaleSettings();

		if (settings.RedirectToDashboardAfterSave){
			setTimeout(() => {
				router.push("/home");
			}, 50);
			return;
		}

		if(this.sale.CrmID && this.sale.CrmID>0){
			await router.push(`/crm/edit/${this.sale.CrmID}`);
		}

		if (conf && conf.NewSaleOnClose) {
			setTimeout(() => {
				router.push(this.getCreateNewRoute());
			}, 50);
		}

		if (this.isPurchaseType) {
			await router.push("/purchase-documents");
		}
	}

	public setContactGroupId(id: number) {
		this._contactGroupId = id;
		let t = SaleService.getTypes(this.getContactGroupID());
		let r = t.filter((type: SaleType) => type.ID == this.sale.TypeID);

		if (r) {
			return;
		}

		let saleType = t[0];
		if (!saleType) return;
		this.setSaleType(saleType);
	}

	public get isPurchaseType(): boolean {
		return this._contactGroupId == 2;
	}

	public getIgnoredSaleTypes(): number[] {
		let isAdmin = UserConfigService.hasCurrentUserPermission((permission: Permissions): boolean => {
			return permission.IsAdmin;
		});
		if (isAdmin) return [10];
		let permissions = UserConfigService.getPermissionSettings();
		return [...SaleService.getTypes(this.getContactGroupID()).filter(f => !permissions.canManageSaleType(f.ID)).map(f => f.ID), 10];
	}

	public async removeRow(row: number | SaleRow) {
		if (typeof (row) == "object") {
			row = this.sale.Rows.indexOf(row);
		}
		if (row < 0) return;
		await this.deleteTaxRows(row);
		this.sale.Rows.splice(row, 1);
		let s = new SaleRow();
		s.Discount = this.sale.Contact?.Discount || 0;
		this.selectedRow = this.sale.Rows[row] || s;
		await this.processFavv();
		this.sale.calculateTotals();
		await this.runAutoSaleRowSettings();
		this.processFostplus();
	}

	public async onProductSelected(product: Product | null) {
		if (!product){
			this.productEditRowState.onProductDeselected();
			return;
		}
		await this.productEditRowState.onProductSelected(product);
	}

	public setLng(event: string) {
		let currentLng = this.sale.getLng();
		let override = false;
		if (this.config) {
			let oldComment = this.config.DefaultComment.getTranslation(currentLng);
			if (this.sale.ToPrintMessage.trim() == oldComment.trim()) {
				override = true;
			}
		}
		this.sale.Lng = event;
		this.setToPrintMessage(override);
	}

	// eslint-disable-next-line max-lines-per-function
	public computeRowUnitPrice(row: SaleRow): number {
		let price = row.Product?.SellPrice1 || 1;
		let priceCategory = this.sale.PriceCategory;

		if (this.sale.Contact) {
			//this.productEditRowState.discount = this.productEditRowState.contactDiscount;
			let result = runPriceRules(this.sale.Contact.PriceRules, row);
			if (result.unitPrice !== undefined){
				if (this.dossierConfig?.AddUpPriceRulesDiscount){
					this.productEditRowState.discount = this.sale.Contact.Discount;
				}else{
					this.productEditRowState.discount = 0;
				}
				return result.unitPrice;
			}
			if (result.priceCategory !== undefined){
				priceCategory = result.priceCategory;
			}
		}
		if (!row.Product) return 0.0;
		row.Sale = this.sale;
		let result = runPriceRules(row.Product.PriceRules, row);
		if (result.unitPrice !== undefined){
			return result.unitPrice;
		}
		if (result.priceCategory !== undefined){
			priceCategory = result.priceCategory;
		}

		result = runPriceRules(this.generalPriceRules, row);
		if (result.unitPrice !== undefined){
			return result.unitPrice;
		}
		if (result.priceCategory !== undefined){
			priceCategory = result.priceCategory;
		}

		if (this.isPurchaseType) {
			return this.getPurchasePrice(row.Product);
		}

		if (row.Product.PriceCategorySalesDates && AuthService.hasModule(MODULE.PRIJSBEDING)) {
			priceCategory = row.Product.PriceCategorySalesDates.getPriceCategoryForDate(new Date()) || priceCategory;
		}
		if (priceCategory != 0) {
			let price = (row.Product as any)["SellPrice" + priceCategory];
			return price;
		}
		return price;
	}

	private getPurchasePrice(product: Product): number {
		for (let supplier of product.Suppliers) {
			if (supplier.ContactID == this.sale.ContactID) {
				return supplier.NettoPrice;
			}
		}
		if (product.BuyNettoPrice != null) {
			return product.BuyNettoPrice;
		}
		return product.getMainSupplier()?.NettoPrice || 0.0;
	}

	public computeRowDiscount(row: SaleRow): number {
		if (row.Product && row.Product.DiscountsDisabled) {
			return 0.0;
		}
		if (this.sale.Contact) {
			for (let rule of this.sale.Contact.PriceRules.reverse()) {
				if (rule.test(row)) {
					if (rule.Discount != 0) {
						if (this.dossierConfig?.AddUpPriceRulesDiscount){
							return rule.Discount + this.sale.Contact.Discount;
						}
						return rule.Discount;
					}
					if(this.isPurchaseType){
						if(rule.BuyPercentage != 0){
							return rule.BuyPercentage;
						}
					}
				}
			}
		}
		if(row.Product){
			row.Sale = this.sale;
			for (let rule of row.Product.PriceRules.reverse()) {
				if (rule.test(row)) {
					if (rule.Discount != 0) {
						return rule.Discount;
					}
				}
			}
		}
		return row.Discount;
	}


	private setVatByRegime(row: SaleRow) {
		if (this.sale.VatRegime == 1) {
			if (row.Product && row.Product.Vat && row.Product.ID != 0) {
				row.Vat = row.Product.Vat.Value;
			}
			if (row.Product && !row.Product.Vat && row.Product.ID != 0){
				row.Vat = VatService.getVatById(row.Product.VatID).Value;
			}
			return;
		}
		let vatRegime = VatService.getVatRegime(this.sale.VatRegime);
		row.Vat = VatService.getVatByValue(vatRegime.getSaleVat()).Value;
	}

	// eslint-disable-next-line max-lines-per-function
	public addMultipleProducts(products: Product[]):SaleRow[] {
		let toAddRows: SaleRow[] = [];
		for (let product of products) {
			let row = new SaleRow();
			row.Product = product;
			row.ProductSku = product.Sku || "";
			row.Discount = this.productEditRowState.contactDiscount;
			row.ProductDescription = product.TranslatedName.getTranslation(this.sale.getLng());
			if (!row.ProductDescription) {
				row.ProductDescription = product.Name;
			}
			this.setVatByRegime(row);
			if (this.productEditRowState.amount) {
				row.setAmount(this.productEditRowState.amount);
			} else {
				row.setAmount(1.0);
			}
			row.Amount2 = product.DefaultValueQty2;
			if (!this.isPurchaseType) {
				let mainSupplier = product.getMainSupplier();
				row.UnitBuyPrice = product.BuyNettoPrice || 0;
				if (product.BuyNettoPrice == null){
					row.UnitBuyPrice = 0.0;
					if (mainSupplier) {
						row.UnitBuyPrice = mainSupplier.NettoPrice;
					}
				}
			}
			row.UnitPrice = this.computeRowUnitPrice(row);
			row.Discount = this.computeRowDiscount(row);
			if (!this.userConfig.getSaleConfig(this.sale.TypeID).DontUseLeeggoed) {
				row.LeeggoedTax = product.LeeggoedTax;
			}
			row.EcoboniTax = product.EcoboniTax;
			row.AccijnzenTax = product.AccijnzenTax;
			row.CustomVatExclusiveTax = product.CustomVatExclusiveTax;
			row.CustomVatInclusiveTax = product.CustomVatInclusiveTax;
			row.calculateTotals(this.sale);
			row.SaleRowConfig.Hidden = this.addRowsAutoHidden;
			row.UnitWeight = product.Weight;
			if (product.Unit != null){
				row.UnitName = product.Unit.Name.getTranslation(this.sale.getLng());
			}
			this.applyMatchedSize(row, product);
			toAddRows.push(row);
		}
		this.addRows(...toAddRows);
		this.sale.calculateTotals();
		this.emit("product-added");
		return toAddRows;
	}

	// eslint-disable-next-line max-lines-per-function
	public createCompositionRows(row: SaleRow): SaleRow[] {
		if (!row.Product) return [];
		if (!this.config) return [];
		if (this.config.DontAddProductComposition) return [];
		let toAddRows:SaleRow[] = [];
		let qty = row.Amount;
		let useStaticVat = isVatRegimeStaticVat(this.sale.VatRegime);
		let staticVat = useStaticVat ? VatService.getVatRegime(this.sale.VatRegime).getSaleVat() : 0;
		for (let compositionRow of row.Product.Composition) {
			let saleRow = new SaleRow();
			saleRow.Vat = useStaticVat ? staticVat : compositionRow.Vat;
			saleRow.UnitBuyPrice = 0.0;
			if (compositionRow.RowConfig.Hidden) {
				saleRow.UnitBuyPrice = 0;
			}
			saleRow.setAmount(compositionRow.Amount * qty);
			saleRow.Duration = compositionRow.Duration;
			saleRow.UnitName = compositionRow.UnitName;
			saleRow.ProductSku = compositionRow.ProductSku;
			saleRow.UnitBuyPrice = compositionRow.UnitBuyPrice || 0;
			if(compositionRow.ReferencedProduct){
				saleRow.UnitBuyPrice = row.Product.BuyPriceComesFromComposition ? 0 : (compositionRow.ReferencedProduct.BuyNettoPrice || 0);
			}
			saleRow.ProductDescription = compositionRow.TranslatedDescription.getTranslationWithoutFallback(this.sale.getLng()) || compositionRow.ProductDescription;
			saleRow.UnitPrice = compositionRow.UnitPrice;
			saleRow.Discount = compositionRow.Discount;
			saleRow.SaleRowConfig = {...compositionRow.RowConfig};
			saleRow.LedgerAccountCode = DossierConfigService.getBookkeepingConfig().DefaultSaleLedgerAccountCode;
			if (compositionRow.ReferencedProduct && compositionRow.ReferencedProduct.LedgerAccountCode) {
				saleRow.LedgerAccountCode = compositionRow.ReferencedProduct.LedgerAccountCode;
			}
			saleRow.Product = compositionRow.ReferencedProduct;
			if (this.isPurchaseType) {
				saleRow.UnitPrice = compositionRow.ReferencedProduct ? this.getPurchasePrice(compositionRow.ReferencedProduct) : 0.0;
				saleRow.Discount = 0.0;
				saleRow.SaleRowConfig.Hidden = false;
			}
			toAddRows.push(saleRow);
		}
		return toAddRows;
	}

	public createTaxRows(row: SaleRow): SaleRow[] {
		if (!row.Product) return [];
		let qty = row.Amount;
		let vat = row.Vat;
		let taxes = row.Product.getTaxRows(qty,vat,(this.sale.Contact?.MainAddress?.CountryCode||"BE"),(this.sale.Contact?.MainAddress?.Lng||"nl-be"));
		return taxes;
	}

	//Update tax rows
	public updateTaxRows(index:number,amount:number){
		for (let i = index + 1; i < this.sale.Rows.length; i++) {
			if (!this.sale.Rows[i].IsTaxRow) break;
			this.sale.Rows[i].Amount = amount;
			this.sale.Rows[i].Amount1 = amount;
			this.sale.Rows[i].Amount2 = 1;
		}
	}

	public async deleteTaxRows(index:number){
		for (let i = index + 1; i < this.sale.Rows.length; i++) {
			if (!this.sale.Rows[i].IsTaxRow) break;
			this.sale.Rows.splice(i, 1);
			i--;
		}
	}

	//Process FAVV tax
	public async processFavv() {
		let config = DossierConfigService.getTaxesConfig().FavvConfig;

		if (!config.FavvProductSku)
			return;

		let total = 0;

		this.sale.Rows.forEach((row: SaleRow) => {
			if (row.Product?.Vat?.Value == 6 && row.ProductSku != config.FavvProductSku) {
				total += (row.Amount * config.FavvCost);
			}
		});
		this.sale.Rows.forEach((row: SaleRow, i: number) => {
			if (row.ProductSku == config.FavvProductSku) {
				this.sale.Rows.splice(i, 1);
			}
		});
		if (total != 0) {
			if (!this.favvProduct.Sku) {
				this.favvProduct = await config.getProduct();
			}

			//let vatRegime = VatService.getVatRegime(this.sale.VatRegime);
			let r = new SaleRow();
			r.ProductSku = config.FavvProductSku;
			r.ProductDescription = this.favvProduct.Name;
			r.UnitPrice = total;
			r.setAmount(1);
			//r.Vat = VatService.getVatByValue(vatRegime.getSaleVat()).Value;
			r.Vat = this.sale.VatRegime == 1 ? 6 : 0;
			this.sale.Rows.push(r);
		}
	}

	public async addRows(...rows: SaleRow[]) {
		let toAddRows: SaleRow[] = [];
		for (let row of rows) {
			let result = await this.ProductTrackingNumbersData.selectAutomaticTrackingNumbersForRow(row);
			toAddRows.push(...result);
		}
		rows = toAddRows;
		toAddRows = [];
		for (let row of rows) {
			row.LedgerAccountCode = DossierConfigService.getBookkeepingConfig().DefaultSaleLedgerAccountCode;
			if (row.Product && row.Product.LedgerAccountCode) {
				row.LedgerAccountCode = row.Product.LedgerAccountCode || row.LedgerAccountCode;
				row.FostplusCode = row.Product.FostplusCode;
			}else{
				row.FostplusCode = "";
			}
			if (this.sale.Rows.indexOf(row) == -1) {
				row.DisplayOrder = this.sale.Rows.length + 1;
				toAddRows.push(row);
				if (row.Product) {
					let compositionRows = this.createCompositionRows(row);
					if (this.isPurchaseType && compositionRows.length > 0) {
						row.UnitPrice = 0.0;
						row.Discount = 0.0;
					}
					toAddRows.push(...compositionRows);
					toAddRows.push(...this.createTaxRows(row));
				}
			}
		}
		this.sale.Rows.push(...toAddRows);
		await this.processFavv();
		this.sale.calculateTotals();
		await this.runAutoSaleRowSettings();
		this.processFostplus();
	}

	// eslint-disable-next-line max-lines-per-function
	public processFostplus(){

		let config = DossierConfigService.getContactsConfig();

		if(this.sale.Contact?.ExtraFields){
			if(config.FostplusCheckExtraField){
				if((this.sale.Contact?.ExtraFields as any)[config.FostplusCheckExtraField]){
					console.log("NO FOSTPLUS");
					return;
				}
			}
		}

		let fostplusTotal = 0.0;
		let fostplusVats:number[] = [];
		for (let r of this.sale.Rows){
			if (!r.FostplusCode) {
				r.FostplusAmount = 0.0;
				continue;
			}
			let item = this.fostplusItems.find(i=>i.Code == r.FostplusCode);
			if (!item) continue;
			r.FostplusAmount = item.Amount;
			fostplusTotal += r.Amount * r.UnitWeight * r.FostplusAmount;
			if (fostplusVats.indexOf(r.Vat) == -1) fostplusVats.push(r.Vat);
		}
		let fostplusRowAmount = 1;
		if (this.sale.isSupposedToHaveNegativeTotalType() && fostplusTotal < 0) {
			fostplusRowAmount = -1;
			fostplusTotal = Math.abs(fostplusTotal);
		}

		let totalRow = this.sale.getFostplusTotalRow();
		if (fostplusTotal == 0)  {
			if (!totalRow) return;
			let i = this.sale.Rows.indexOf(totalRow);
			if (i != -1) this.sale.Rows.splice(i,1);
			return;
		}
		if (!totalRow){
			let row =  new SaleRow();
			row.BookYear = this.sale.BookYear;
			row.Amount1 = fostplusRowAmount;
			row.Amount2 = 1;
			row.Amount = fostplusRowAmount;
			row.ProductDescription = i18n.t("common.taxes.fostplus").toString();
			this.sale.Rows.push(row);
			totalRow = row;
		}else{
			let i = this.sale.Rows.indexOf(totalRow);
			if (i != this.sale.Rows.length - 1){
				this.sale.Rows.splice(i, 1);
				this.sale.Rows.push(totalRow);
			}
		}
		totalRow.Amount1 = fostplusRowAmount;
		totalRow.Amount = fostplusRowAmount;
		totalRow.UnitPrice = fostplusTotal;
		totalRow.Vat = this.getFostplusVat(fostplusVats);
		totalRow.DisplayOrder = this.sale.Rows.length+1;
		this.sale.calculateTotals();
	}

	private getFostplusVat(productVats:number[]):number {
		if (this.sale.hasEnforcedVatRegime()) {
			return VatService.getVatRegime(this.sale.VatRegime).getSaleVat();
		}
		if (productVats.length == 1) return productVats[0];
		return 21;
	}

	private compareFilters(filters1: Condition[], filters2: Condition[]): boolean {
		if (filters1.length !== filters2.length) return false;
		for (let i = 0; i < filters1.length; i++) {
			const f1 = filters1[i];
			const f2 = filters2[i];
			if (f1.Prop !== f2.Prop || f1.Operator !== f2.Operator || f1.Value !== f2.Value) {
				return false;
			}
		}
		return true;
	}

	public async addPriceRule(rule: ContactPriceRule) {
		if (!AuthService.hasModule(MODULE.PRIJSBEDING)) return;
		if (!this.sale.Contact) return;
		rule.ContactID = this.sale.ContactID;
		let foundRule = null as null | ContactPriceRule;
		for (let oldRule of this.sale.Contact.PriceRules) {
			if (this.compareFilters(rule.Filters, oldRule.Filters)) {
				foundRule = oldRule;
				break;
			}
		}
		let contactService = getContactServiceByGroupId(this.sale.Contact.GroupID);
		let newDisplayOrder = 0;
		if (this.sale.Contact.PriceRules.length > 0) {
			newDisplayOrder = this.sale.Contact.PriceRules.sort((a, b) => a.DisplayOrder - b.DisplayOrder)[0].DisplayOrder + 1;
		}
		if (foundRule) {
			foundRule.DisplayOrder = newDisplayOrder;
			foundRule.Price = rule.Price;
			foundRule.Discount = rule.Discount;
			await contactService.updatePriceRule(this.sale.Contact, foundRule);
		} else {
			rule.DisplayOrder = newDisplayOrder;
			rule.ContactID = this.sale.ContactID;
			await contactService.addPriceRule(this.sale.Contact, rule);
		}
		await this.vue.$wf.notify(this.vue.$ct("components.sales.added-price-rule"), "success", 3000, "check");
	}

	public async onUnitPriceKeyDown(event: KeyboardEvent): Promise<void> {
		if (event.key != "F6" && event.key != "F3") return;
		if (event.key == "F3") {
			let p = parseFloat((event.target as HTMLInputElement).value);
			this.productEditRowState.setUnitPrice(p);
			if (!this.sale.ContactID || !this.productEditRowState.product?.Sku) {
				return;
			}
			this.lastPurchaseModalOpen = true;
			return;
		}
		if (!this.productEditRowState.product) return;
		if (!event.target) return;
		event.preventDefault();
		event.stopPropagation();
		let rule = new ContactPriceRule();
		rule.Price = parseFloat((event.target as HTMLInputElement).value);
		if (Number.isNaN(rule.Price)) return;
		let condition = new Condition();
		condition.Prop = "ProductSku";
		condition.Operator = Operator.EQ;
		condition.Value = this.productEditRowState.product.Sku || "";
		requestAnimationFrame(() => {
			this.productEditRowState.setUnitPrice(rule.Price);
		});
		rule.Filters = [condition];
		await this.addPriceRule(rule);
	}

	public async onDiscountKeyDown(event: KeyboardEvent): Promise<void> {
		if (event.key != "F6") return;
		if (!this.productEditRowState.product) return;
		if (!event.target) return;
		event.preventDefault();
		event.stopPropagation();
		let rule = new ContactPriceRule();
		rule.Price = 0;
		rule.Discount = parseFloat((event.target as HTMLInputElement).value);
		if (Number.isNaN(rule.Discount)) return;
		let condition = new Condition();
		condition.Prop = "ProductSku";
		condition.Operator = Operator.EQ;
		condition.Value = this.productEditRowState.product.Sku || "";
		requestAnimationFrame(() => {
			this.productEditRowState.setDiscount(rule.Discount);
		});
		rule.Filters = [condition];
		await this.addPriceRule(rule);
	}

	public isSameTypeIdForNumbering(typeId1:number, typeId2:number):boolean{
		if (typeId1 == 0 && typeId2 != 0) return false;
		if (typeId1 != 0 && typeId2 == 0) return false;
		if (typeId1 <= 2 && typeId2 <= 2){
			return true;
		}
		return typeId1 == typeId2;
	}

	public async loadNextFriendlyId(): Promise<void> {
		if (this.sale.ID || this.savedComputedFriendlyId.overridePreventFetch) {
			if (this.sale.JournalID == this.savedComputedFriendlyId.journalId && this.isSameTypeIdForNumbering(this.sale.TypeID, this.savedComputedFriendlyId.typeId)) {
				this.sale.ComputedFriendlyID = this.savedComputedFriendlyId.computedFriendlyId;
				this.sale.FriendlyID = this.savedComputedFriendlyId.friendlyId;
				return;
			}
		}
		if (this.sale.JournalID == this.fetchedNextComputedFriendlyId.journalId &&
			this.sale.ComputedFriendlyID != "" &&
			this.isSameTypeIdForNumbering(this.sale.TypeID, this.fetchedNextComputedFriendlyId.typeId)) return;
		if (this.sale.JournalID == 0) {
			this.sale.JournalID = 1;
		}
		let journalId = this.sale.JournalID;
		let typeId = this.sale.TypeID;
		let result = await SaleService.getNextAvailableComputedID(typeId, journalId);
		if (this.sale.TypeID != typeId) return;
		if (this.sale.JournalID != journalId) return;
		this.fetchedNextComputedFriendlyId.computedFriendlyId = result.computedFriendlyId;
		this.fetchedNextComputedFriendlyId.friendlyId = result.friendlyId;
		this.fetchedNextComputedFriendlyId.journalId = journalId;
		this.fetchedNextComputedFriendlyId.typeId = typeId;
		this.sale.FriendlyID = result.friendlyId;
		this.sale.ComputedFriendlyID = result.computedFriendlyId;
	}

	private async afterScannerInput() {
		setTimeout(() => {
			this.productEditRowState.amount = 1;
			this.productEditRowState.amount1 = 1;
			this.productEditRowState.amount2 = 1;
			this.productEditRowState.focusQty();
			this.scrollToBottom();
		}, 150);
	}
	public focusQty(){
		this.productEditRowState.focusQty();
	}

	public focusAfterContactSelect(){
		if (this.contactInfoModal != OpenClientInfoModalAfterSelectOptions.OFF) return;
		let field = UserConfigService.getSaleSettings().NewSaleAutoFocusField;
		setTimeout(() => {
			if (field == "sku") {
				this.productEditRowState.focusSku();
				return;
			}
			this.productEditRowState.focusQty();
		}, 100);
	}
	// eslint-disable-next-line max-lines-per-function
	public async searchProduct(input:string){
		try{
			var product = await ProductService.findBySku(input);
		}catch(err){
			let hErr = err as HttpError;
			hErr.dontShow = true;
			if (input.length < 13) {
				var product = await ProductService.findBySku(`${"0".repeat(13-input.length)}${input}`);
			}else if (input.length == 13){
				let indexOfNonZeroChar = input.split("").findIndex(a=>a != "0");
				input = input.substring(indexOfNonZeroChar);
				var product = await ProductService.findBySkuMathcAfter0(input);
			}else{
				throw err;
			}
		}

		if (!product) {
			this.vue.$wf.notify(i18n.t("components.sales.product-not-found"), "danger", 3000, "exclamation-triangle");
			return;
		}
		return product;

	}

	public async trySelectContactByBarcode(input:string):Promise<boolean> {
		if (!this.loyalty.isEnabled()) return false;
		try {
			let contact = await CustomerService.getByBarcode(input);
			await this.selectContact(contact);
			return true;
		} catch (err) {
			(err as HttpError).dontShow = true;
			return false;
		}
	}
	// eslint-disable-next-line max-lines-per-function
	public async onScannerInput(input: string) {
		if (this.loyalty.isEnabled() && input.length == 13 && input.startsWith(LOYALTY_BARCODE_PREFIX)) {
			if (await this.trySelectContactByBarcode(input)) return;
		}

		if (this.carSelectData.isOpen) {
			setTimeout(async ()=>{
				let result = await CarService.search(input);
				if (result.length == 0)return;
				this.carSelectData.car = result[0];
			}, ScannerListener.AFTER_SCAN_CLEAR_ACTIVE_INPUIT_TIMEOUT);
			return;
		}

		if (this.userConfig.OpenSearchBrowseOnScannerInput) {
			this.productEditRowState.openProductSearchBrowse(input);
			return;
		}

		let product:Product | undefined;
		try{
			product = await this.searchProduct(input);
		}catch(err){
			let hErr = err as HttpError;
			if (hErr.status == 404) {
				if (await this.trySelectContactByBarcode(input)) return;
				if (UserConfigService.getSaleSettings().OpenCreateProductModalOnScanAndProductNotFound) {
					this.productEditRowState.openProductCreateView(input);
					return;
				}
			}
			throw err;
		}
		if (!product) {
			return;
		}

		//Scanning negative amounts = teruggave
		if(this.productEditRowState.amount >= 0){
			for (let i = 0; i < this.sale.Rows.length; i++) {
				let row = this.sale.Rows[i];
				// Only merge into an existing row of the same product AND the same size, so
				// scanning two different sizes of one product yields two separate rows.
				if (row.ProductSku == product.Sku && (row.SizeTableEntryID ?? null) == (product.MatchedSizeTableEntryID ?? null)) {
					if (this.productEditRowState.amount) {
						row.Amount1 = row.Amount1 + this.productEditRowState.amount1;
					} else {
						row.Amount1++;
					}
					row.Amount = this.dossierConfig?.UseAmount2AsMultiplier ? row.Amount1 * row.Amount2 : row.Amount1;
					for (let c of product.Composition) {
						for (let r of this.sale.Rows) {
							if (r.ProductSku == c.ProductSku && r.ProductDescription == c.ProductDescription) {
								r.Amount1 += c.Amount;
								r.Amount = this.dossierConfig?.UseAmount2AsMultiplier ? r.Amount1 * r.Amount2 : r.Amount1;
							}
						}
					}
					let taxRows = this.createTaxRows(row);
					for (let taxRow of taxRows){
						for (let c = i+1; c < this.sale.Rows.length; c++){
							let thisRow = this.sale.Rows[c];
							if (!thisRow.IsTaxRow) continue;
							if (taxRow.ProductDescription != thisRow.ProductDescription) continue;
							thisRow.Amount1 = taxRow.Amount1;
							break;
						}
					}
					this.sale.calculateTotals();
					await SaleService.saleEditOnRowAddScript(this, row, services);
					this.productEditRowState.focusQty();
					this.afterScannerInput();
					this.setJustScannedRow(row);
					return;
				}
			}
		}

		// Check if there's a selected row without ProductSku - set product on that row
		if (this.selectedRow && !this.selectedRow.ProductSku && this.sale.Rows.includes(this.selectedRow)) {
			let row = this.selectedRow;
			this.setProductOnRow(row, product);
			this.applyMatchedSize(row, product);
			this.sale.calculateTotals();
			this.setJustScannedRow(row);
			this.selectedRow = new SaleRow();
			this.afterScannerInput();
			return;
		}

		let rows = this.addMultipleProducts([product]);
		for (const row of rows) {
			await SaleService.saleEditOnRowAddScript(this, row, services);
		}
		if (rows.length > 0 ){
			this.setJustScannedRow(rows[0]);
		}
		this.productEditRowState.amount = 1.0;
		this.productEditRowState.amount1 = 1.0;
		this.productEditRowState.amount2 = 1.0;
		this.afterScannerInput();
	}

	public scrollToBottom() {
		var container = document.querySelector("#products-table > tbody");
		if (container)
			container.scrollTop = (container.scrollHeight + 29);
	}

	public scrollToTop() {
		var container = document.querySelector("#products-table > tbody");
		if (container)
			container.scrollTop = 0;
	}

	public async onVatRegimeChange(vatRegime: number) {
		this.sale.VatRegime = vatRegime;
		let saleVat = VatService.getVatRegime(this.sale.VatRegime).getSaleVat();
		this.productEditRowState.vatItem = VatService.getVatByValue(saleVat);
		if (this.sale.Rows.length == 0) return;
		let message = this.vue.$ct("components.sales.ask-for-vat-switch");
		let confirm = await this.vue.$wf.confirm(message, this.vue.$t("common.yes"), this.vue.$t("common.no"), this.vue.$ct("common.warning"), "info");
		if (confirm) {
			this.sale.Rows.map(u => {
				u.Vat = saleVat;
			});
			this.sale.calculateTotals();
		}
		this.processFostplus();
	}

	public getDisplayedRowProductDescription(description: string) {
		return description.replaceAll("{__NEW_LINE__}", "<br>").replaceAll("{__DOUBLE_SPACE__}", "&nbsp;&nbsp;");
	}

	public insertRowBefore(index:number = -1) {
		if (index == -1){
			index = this.sale.Rows.findIndex((r: SaleRow) => r == this.selectedRow);
		}
		let row = new SaleRow();
		this.setVatByRegime(row);
		row.setAmount(1);
		row.Duration = 0;
		row.ProductSku = "";

		this.sale.Rows.splice(index, 0, row);
		this.selectedRow = this.sale.Rows[index];
	}


	public selectNextRow() {
		let index = this.sale.Rows.findIndex((r: SaleRow) => r == this.selectedRow);
		if ((index + 1) < this.sale.Rows.length) {
			this.selectedRow = this.sale.Rows[index + 1];
			return true;
		}
		return false;
	}

	public toggleBold(){
		this.selectedRow.getRowConfig().Bold = !this.selectedRow.getRowConfig().Bold;
	}

	public toggleUnderline(){
		let t = this.selectedRow.ProductDescription;
		if (t.includes("<u>")) {
			// Remove <u> and </u> tags
			this.selectedRow.ProductDescription = t.replace(/<u>/g, "").replace(/<\/u>/g, "");
		} else {
			// Wrap the string with <u></u> tags
			this.selectedRow.ProductDescription = "<u>" + t + "</u>";
		}
	}

	public selectPreviousRow() {
		let index = this.sale.Rows.findIndex((r: SaleRow) => r == this.selectedRow);
		if (index > 0) {
			this.selectedRow = this.sale.Rows[index - 1];
		}
	}

	// Only works if sale type contact group is 2
	// eslint-disable-next-line max-lines-per-function
	public async addProductsWithNotEnoughInStockBySelectedSupplier(groupIds:number[]){
		if (!this.sale.Contact) return;
		if (this.sale.Contact.GroupID != 2) return;
		let groups = await ProductGroupService.getTopLevelGroups();
		let openGroupModal = DossierConfigService.getStockLocationConfig().OutOfStockSelectedSupplierSelectGroup;
		if (groups.length > 0 && openGroupModal && !this.addProductsWithNotEnoughInStockBySelectedSupplierSelectGroupModalOpen) {
			this.addProductsWithNotEnoughInStockBySelectedSupplierSelectGroupModalOpen = true;
			return;
		}
		try{
			this.processingMessage = this.vue.$ct("components.sales.fetching-products");
			let products = await ProductService.getProductsWithLessStockThenMinStockBySupplier(this.sale.Contact, groupIds);
			let settings = DossierConfigService.getStockLocationConfig();
			let rows = products.filter(p=>p.Stock != null).map(p=>{
				if (!p.Stock) return new SaleRow();
				let row = new SaleRow();
				row.Product = p;
				row.ProductDescription = p.getName(this.sale.getLng());
				row.ProductSku = p.Sku || "";
				row.Amount2 = p.DefaultValueQty2;
				row.UnitPrice = p.BuyNettoPrice || 0;
				let amount = p.Stock.MinStockQty1;
				for (let i = 1; i <= StockLocationConfig.MAX_ID; i++) {
					let stockSettings = settings.getLocationSettings(i);
					if (stockSettings.AddToAutomaticOrderToSupplier == AddToAutomaticOrderToSupplier.ADD) {
						amount += p.Stock.getStockAtLocation(i);
					}else if (stockSettings.AddToAutomaticOrderToSupplier == AddToAutomaticOrderToSupplier.SUBTRACT) {
						amount -= p.Stock.getStockAtLocation(i);
					}
				}
				if (p.MainSupplier && amount > 0) {
					amount = Math.max(p.MainSupplier.MinOrderQty, amount);
				}
				row.setAmount(amount);
				return row;
			}).filter(r=>r.Amount > 0);
			await this.addRows(...rows);
		}catch(err){

		}finally{
			this.processingMessage = null;
		}
	}
	private applyMatchedSize(row: SaleRow, product: Product) {
		row.SizeTableEntryID = product.MatchedSizeTableEntryID ?? null;
		row.SizeTableEntry = null;
		if (!row.SizeTableEntryID) return;
		let entry = product.SizeTable?.Entries.find(e => e.ID === row.SizeTableEntryID);
		if (entry) {
			row.SizeTableEntry = entry;
			return;
		}
		if (!product.SizeTableID) return;
		SizeTableService.getById(product.SizeTableID).then(table => {
			row.SizeTableEntry = table.Entries.find(e => e.ID === row.SizeTableEntryID) ?? null;
		}).catch(() => undefined);
	}

	// eslint-disable-next-line max-lines-per-function
	private setProductOnRow(row: SaleRow, product: Product) {
		row.Product = product;
		row.ProductSku = product.Sku || "";
		row.Discount = this.productEditRowState.contactDiscount;
		row.ProductDescription = product.TranslatedName.getTranslation(this.sale.getLng());
		if (!row.ProductDescription) {
			row.ProductDescription = product.Name;
		}
		this.setVatByRegime(row);
		if (this.productEditRowState.amount) {
			row.setAmount(this.productEditRowState.amount);
		} else {
			row.setAmount(1.0);
		}
		row.Amount2 = product.DefaultValueQty2;
		if (!this.isPurchaseType) {
			let mainSupplier = product.getMainSupplier();
			row.UnitBuyPrice = product.BuyNettoPrice || 0;
			if (product.BuyNettoPrice == null) {
				row.UnitBuyPrice = 0.0;
				if (mainSupplier) {
					row.UnitBuyPrice = mainSupplier.NettoPrice;
				}
			}
		}
		row.UnitPrice = this.computeRowUnitPrice(row);
		row.Discount = this.computeRowDiscount(row);
		if (!this.userConfig.getSaleConfig(this.sale.TypeID).DontUseLeeggoed) {
			row.LeeggoedTax = product.LeeggoedTax;
		}
		row.EcoboniTax = product.EcoboniTax;
		row.AccijnzenTax = product.AccijnzenTax;
		row.CustomVatExclusiveTax = product.CustomVatExclusiveTax;
		row.CustomVatInclusiveTax = product.CustomVatInclusiveTax;
		row.calculateTotals(this.sale);
		row.SaleRowConfig.Hidden = this.addRowsAutoHidden;
		row.UnitWeight = product.Weight;
		if (product.Unit != null) {
			row.UnitName = product.Unit.Name.getTranslation(this.sale.getLng());
		}
		row.LedgerAccountCode = DossierConfigService.getBookkeepingConfig().DefaultSaleLedgerAccountCode;
		if (product.LedgerAccountCode) {
			row.LedgerAccountCode = product.LedgerAccountCode;
		}
		row.FostplusCode = product.FostplusCode || "";
	}

	public setJustScannedRow(row:SaleRow) {
		this.justScannedRow = row;
		this.justScannedRowWasScannedThisTick = true;
		let threadId = v4();
		this.justScannedRowThreadId = threadId;
		setTimeout(()=>{
			if (this.justScannedRowThreadId != threadId) return;
			this.justScannedRowWasScannedThisTick = false;
		}, 1000);
		setTimeout(()=>{
			if (this.justScannedRowThreadId != threadId) return;
			this.justScannedRow = null;
		}, this.justScannedRowEffectTime);
	}

	public openContactExtraInfoEdit(){
		if (!this.sale.Contact) return;
		this.contactExtraInfoEditState.open(this.sale.Contact);
	}

	public async updateAllRowsToLatestPrices(rows:SaleRow[] = this.sale.Rows){
		try{
			this.processingMessage = this.vue.$ct("components.sales.update-all-rows-to-latest-prices");
			let skus = rows.map(r=>r.ProductSku);
			skus = skus.filter((s,i)=>{
				if (!s) {
					return false;
				}
				return skus.indexOf(s)==i;
			});
			let products = await ProductService.getProductsBySkus(skus, {fullPreloads: true});
			for (let row of rows) {
				if (!row.ProductSku) continue;
				for (let product of products) {
					if (row.ProductSku != product.Sku) continue;
					row.Product = product;
					row.UnitPrice = this.computeRowUnitPrice(row);
				}
			}
			this.sale.calculateTotals();
		}catch(err){

		}finally{
			this.processingMessage = null;
		}

	}

	public updateCurrencyRate(){
		if (this.sale.CurrencyID <= 1) return;
		let currencies = CurrencyService.getCurrencies();
		let currency = currencies.find(c => c.ID === this.sale.CurrencyID);
		if (!currency) return;
		let oldRate = this.sale.CurrencyRate;
		let newRate = currency.Rate;
		if (oldRate === newRate) {
			this.vue.$wf.dialog(i18n.t("components.sales.currency-rate-already-up-to-date"), i18n.t("common.ok"), i18n.t("components.sales.update-currency-rate"));
			return;
		}
		for (let row of this.sale.Rows) {
			let unitPriceMc = row.UnitPrice / oldRate;
			row.UnitPrice = unitPriceMc * newRate;
		}
		this.sale.CurrencyRate = newRate;
		this.productEditRowState.currencyRate = newRate;
		this.sale.calculateTotals();
		this.vue.$wf.dialog(i18n.t("components.sales.currency-rate-updated", {oldRate, newRate}), i18n.t("common.ok"), i18n.t("components.sales.update-currency-rate"));
	}

	applySaleDiscount(discount:number, full:boolean) {
		for (let row of this.sale.Rows){
			if (row.IsTaxRow) {
				continue;
			}
			if (row.Product && row.Product.DiscountsDisabled && row.Discount == 0) {
				continue;
			}
			if (full && row.Discount != 0) {
				continue;
			}
			row.Discount = discount;
		};
	}

	deInit(){
		this.openedClientsWatcher.deInit();
	}

	async runAutoSaleRowSettings(){
		if (this.autoSaleRowSettings.length == 0)return;
		for (let setting of this.autoSaleRowSettings){
			setting.runSetting(this);
		}
		//	this.sale.sortRows();
		this.sale.calculateTotals();
	}

	async uploadCsvRows(file:File, options:ICsvToSaleRowsOptions = {}){
		if (this.csvRowsModalState == LoadCsvRowsModalState.PROCESSING) return;
		this.csvRowsModalState = LoadCsvRowsModalState.PROCESSING;
		try{
			let rows = await csvToSaleRows(file, this, options);
			await this.addRows(...rows);
			this.csvRowsModalState = LoadCsvRowsModalState.CLOSED;
		}catch(err){
			let error = err as Error;
			this.vue.$wf.dialog(error.message, i18n.t("common.ok"), i18n.t("common.error"), "warning");
			this.csvRowsModalState = LoadCsvRowsModalState.OPEN;
		}
	}

	public openImportSales(contactGroupId:number = this.getContactGroupID()){
		this.importSalesModal.saleRowsShown = false;
		this.importSalesModal.shown = true;
		this.importSalesModal.disableContentFilter = contactGroupId != this.getContactGroupID();
		this.importSalesModal.contactGroupId = contactGroupId;
	}

	public openImportSaleRows(){
		this.importSalesModal.shown = false;
		this.importSalesModal.saleRowsShown = true;
		this.importSalesModal.disableContentFilter = false;
		this.importSalesModal.contactGroupId = this.getContactGroupID();
	}

	public toggleProfit() {
		this.profitVisible = !this.profitVisible;
		let settings = UserConfigService.getSaleSettings();
		settings.ShowProfitBar = this.profitVisible;
		UserConfigService.setSaleSettings(settings);
	}

	public toggleStockInfo() {
		this.stockInfoVisible = !this.stockInfoVisible;
		let settings = UserConfigService.getSaleSettings();
		settings.ShowStockInfo = this.stockInfoVisible;
		UserConfigService.setSaleSettings(settings);
	}

	public async createPublicLink() {
		this.publicLinkModal.shown = true;
		this.publicLinkModal.link = await SaleService.generatePublicUrl(this.sale);
	}

	async deleteAllSaleRows(){
		let text = this.vue.$ct("confirm-delete-sale-rows");
		let confirm = await this.vue.$wf.confirm(text, this.vue.$t("common.yes"), this.vue.$t("common.no"), this.vue.$ct("common.warning"), "warning");
		if (!confirm) return;
		this.sale.Rows = [];
	}
}
